import {getStoreList,getRecordList,getSelfStoreList,getPoolCount,getPoolList,toChart} from '../io/api.js'//应用mutation
export const setUser = ({commit},user) => {
  commit("userStatus",user)
}
// //获取用户头像
// export const setImage = ({commit},imageUrl) => {
//   commit("userImageGet",imageUrl)
// }
export const setToken = ({commit},userToken) => {
  commit("userToken",userToken)
}
export default {
	// 医案库列表
	getStore_list({state,commit},params){
        getStoreList(params).then(res=>{
            let data = res.data;
            if (data && data.code == 0) {
                commit('setMedicalList',data.data)
                commit('setMedicalLoading',false)
            }else{
				commit('setMedicalLoading',false)
                commit('setToast',{type:'error',info:data.msg||'保存成功'})
            }
        })
    },
	// 医案库详情列表
	getRecord_list({state,commit},params){
        getRecordList(params).then(res=>{
            let data = res.data;
            if (data && data.code == 0) {
                commit('setMedicalDeleteList',data.data)
                commit('setMedicalLoading',false)
            }else{
				commit('setMedicalLoading',false)
                commit('setToast',{type:'error',info:data.msg||'保存成功'})
            }
        })
    },
	// 分析池条数
	getAnalysisNum({state,commit},params){
		getPoolCount().then(res=>{
			let data = res.data;
			if (data && data.code == 0) {
                commit('setAnalysisNum',data.data)
                // commit('setMedicalLoading',false)
            }else{
				//  commit('setToast',{type:'error',info:data.msg||'请求失败～'})
            }
		})
	},
    // 分析池数据
	get_poolList({state,commit},params){
		getPoolList(params).then(res=>{
			let data = res.data;
			if (data && data.code == 0) {
                commit('setPoolList',data.data)
                commit('setMedicalLoading',false)
            }else{
				commit('setMedicalLoading',false)
                commit('setToast',{type:'error',info:data.msg||'保存成功'})
            }
		})
	},
    //获取医案库列表
    getSelfStore_list({state,commit},params){
        getSelfStoreList().then(res=>{
            let data = res.data;
            if(data&&data.code==0){
                commit('setLibrarylistoptions',data.data)
            }else{
                commit('setToast',{type:'error',info:data.msg||'保存成功'})
                // this.$message.error(data.msg||'请求失败～');
            }
            
        })
    },
    // 获
}